import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(timezone);

/** date in ISO format. For example: "2023-08-14T20:54:13Z" */
export const formatDate = (date: string | undefined, formatStr?: string, timeZone?: string) => {
  return dayjs(date).tz(timeZone).format(formatStr);
};
